import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(auth)/register/page.tsx");
